export default __webpack_public_path__ + "static/media/paypal.6a0ccab2.png";